import { Dialog, dialogBaseClasses } from '@ori-ui/components';
import { paperClasses, styled } from '@ori-ui/mui';

import type { DialogProps } from './types';

export const Root = styled(Dialog, { shouldForwardProp: (propName) => propName !== 'zIndex' })<
  Pick<DialogProps, 'zIndex'> & { isInfo?: boolean }
>`
  z-index: ${({ zIndex }) => zIndex};

  button {
    z-index: ${({ zIndex }) => (typeof zIndex === 'number' ? zIndex + 1 : undefined)};
  }

  & .${dialogBaseClasses.closeButton} {
    z-index: 10;
  }

  & .${paperClasses.root} {
    ${({ theme }) => theme.breakpoints.up('sm')} {
      width: ${(props) => (props.isInfo ? '390px' : '720px')};
      max-width: 95vw;
    }

    ${({ theme }) => theme.breakpoints.up('md')} {
      height: ${(props) => (props.isInfo ? 'auto' : '450px')};
      overflow: visible;
      width: ${(props) => (props.isInfo ? '390px' : '900px')};
      max-width: 80vw;
    }

    ${({ theme }) => theme.breakpoints.up('lg')} {
      max-width: 75vw;
    }
  }
`;
